import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { AdminLayout } from '@/components/Layout';
import { lazyImport } from '@/utils/lazyImport';
import { LoadingOverlay } from '@/components/Element/Loading';

const { DocumentMonitoring } = lazyImport(() => import('@/features/Admin'), 'DocumentMonitoring');

const AppAdmin = () => {
  return (
    <AdminLayout>
      <Suspense
        fallback={<LoadingOverlay loading={true} />}
      >
        <Outlet />
      </Suspense>
    </AdminLayout>
  );
};

export const protectedRoutes = [
  {
    path: '/admin',
    element: <AppAdmin />,
    children: [
      { path: 'document-monitoring', element: <DocumentMonitoring /> },
      // { path: '*', element: <Navigate to="/" /> },
    ],
  },
];
